<template>
  <div>
    <hr class="my-4 md:min-w-full" />

    <h6
      class="md:min-w-full text-gray-600 text-xs uppercase font-bold block pt-1 pb-4 no-underline"
    >
      Basic Pages
    </h6>

    <ul class="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
      <li class="items-center">
        <router-link
          class="text-gray-800 hover:text-gray-600 text-xs uppercase py-3 font-bold block"
          to="/"
        >
          <i class="fas fa-home text-gray-400 mr-2 text-sm"></i>
          Home
        </router-link>
      </li>

      <li class="items-center">
        <router-link
          class="text-gray-800 hover:text-gray-600 text-xs uppercase py-3 font-bold block"
          :to="{ path: '/user/' + currentUser.id + '/dashboard' }"
        >
          <i class="fas fa-columns text-gray-400 mr-2 text-sm"></i>
          Dashboard
        </router-link>
      </li>

      <li class="items-center">
        <router-link
          class="text-gray-800 hover:text-gray-600 text-xs uppercase py-3 font-bold block"
          :to="{ path: '/user/' + currentUser.id + '/teams' }"
        >
          <i class="fas fa-user text-gray-400 mr-2 text-sm"></i>
          My Teams
        </router-link>
      </li>

      <li class="items-center">
        <router-link
          class="text-gray-800 hover:text-gray-600 text-xs uppercase py-3 font-bold block"
          :to="{ path: '/user/' + currentUser.id + '/incidents' }"
        >
          <i class="fas fa-boxes text-gray-400 mr-2 text-sm"></i>
          My Incidents
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
/* 
  Class: SidebarBasic
  Description: This class representing a user sidebar of the application.
*/

export default {
  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Obtain current user object from the store. 
    */
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  /* 
    Check if user is authenticated.
  */
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  }
};
</script>
